import React, { useEffect } from "react";
import { Flex, Grid, GridItem, Box, Text } from "@chakra-ui/react";
import { barChartData } from "../data/mock";
import DashboardBarChart from "../components/DashboardBarChart";
import FinancePieChart from "../components/FinancePieChart";
import DasboardCards from "../components/DasboardCards";
import { useDispatch } from "react-redux";
import { fetchFinanceDashboard } from "../redux/slices/dashboardSlice";

const FinanceDashboard = () => {
  const dispatch = useDispatch();
  // const financeDashboardData = useSelector(
  //   (state) => state?.dashboard?.financeDashboard
  // );
  // console.log("financeDashboardData", financeDashboardData);

  useEffect(() => {
    dispatch(fetchFinanceDashboard());
  }, [dispatch]);

  const data = [
    // {
    //   name: "Total Amount From Event Application",
    //   number: financeDashboardData?.eventApplicationTotal,
    //   colors: [],
    //   pieChartData: [],
    // },
    // {
    //   name: "Total Amount From Exam Application",
    //   number: financeDashboardData?.examApplicationTotal,
    //   colors: [],
    //   pieChartData: [],
    // },
    // {
    //   name: "Total Amount From Event Application",
    //   number: 20,
    //   colors: ["#EFF0F6", "#953B8B"],
    //   pieChartData: [
    //     { name: "Members", value: 5000 },
    //     { name: "Non-members ", value: 5000 },
    //   ],
    // },
  ];
  return (
    <>
      <Text mt={10}></Text>
      <Flex
        gap={5}
        minH={"100vh"}
        flexDirection={["column", "column", "column", "row"]}
      >
        <Flex
          flexDirection={"column"}
          gap={"20px"}
          py={"30px"}
          px={3}
          w={["100%", "100%", "100%", "70%", "75%"]}
        >
          <Grid
            templateColumns={[
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(3, 1fr)",
            ]}
            gap={[5, 5, 5, 3]}
          >
            {data?.map((item, index) => (
              <GridItem key={index}>
                <DasboardCards
                  name={item?.name}
                  number={item?.number}
                  colors={item?.colors}
                  pieChartData={item?.pieChartData}
                />
              </GridItem>
            ))}
          </Grid>
          <DashboardBarChart barChartData={barChartData} />
        </Flex>
        <Box mt={7} width={["100%", "100%", "100%", "30%", "25%"]}>
          <FinancePieChart />
        </Box>
      </Flex>
    </>
  );
};

export default FinanceDashboard;
